// HubSpot Form Modal Handler

console.log('[Modal] Script loaded');

document.addEventListener('DOMContentLoaded', function() {
  console.log('[Modal] DOMContentLoaded fired');
  initHubSpotModals();
});

// También ejecutar si ya está cargado el DOM
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initHubSpotModals);
} else {
  initHubSpotModals();
}

function initHubSpotModals() {
  console.log('[Modal] Initializing modal handler');
  
  // Delegación de eventos para botones que abren modales
  document.addEventListener('click', function(e) {
    const openButton = e.target.closest('[data-open-modal]');
    if (openButton) {
      e.preventDefault();
      const modalId = openButton.getAttribute('data-open-modal');
      console.log('[Modal] Open button clicked, modalId:', modalId);
      openModal(modalId);
    }

    // Cerrar modal cuando se hace click en el botón X
    const closeButton = e.target.closest('.hubspot-modal-close');
    if (closeButton) {
      const modal = closeButton.closest('.hubspot-modal-overlay');
      if (modal) {
        console.log('[Modal] Close button clicked');
        closeModal(modal.getAttribute('data-modal-id'));
      }
    }
  });

  // Cerrar modal cuando se hace click fuera del contenido
  document.addEventListener('click', function(e) {
    if (e.target.classList.contains('hubspot-modal-overlay')) {
      const modalId = e.target.getAttribute('data-modal-id');
      console.log('[Modal] Overlay clicked, closing modal:', modalId);
      closeModal(modalId);
    }
  });

  // Cerrar modal con tecla ESC
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      const activeModal = document.querySelector('.hubspot-modal-overlay.active');
      if (activeModal) {
        console.log('[Modal] ESC pressed, closing modal');
        closeModal(activeModal.getAttribute('data-modal-id'));
      }
    }
  });
}

function openModal(modalId) {
  const modal = document.getElementById(modalId);
  console.log('[Modal] openModal called with id:', modalId);
  console.log('[Modal] Modal element found:', !!modal);
  
  if (modal) {
    modal.classList.add('active');
    modal.style.display = 'flex !important';
    modal.style.position = 'fixed';
    modal.style.top = '0';
    modal.style.left = '0';
    modal.style.right = '0';
    modal.style.bottom = '0';
    modal.style.width = '100%';
    modal.style.height = '100%';
    modal.style.zIndex = '99999';
    modal.style.justifyContent = 'center';
    modal.style.alignItems = 'center';
    
    document.body.style.overflow = 'hidden';
    console.log('[Modal] Modal opened successfully with iframe');
  } else {
    console.error('[Modal] Modal with id', modalId, 'not found');
  }
}

function closeModal(modalId) {
  const modal = document.getElementById(modalId);
  console.log('[Modal] closeModal called with id:', modalId);
  
  if (modal) {
    modal.classList.remove('active');
    document.body.style.overflow = '';
    console.log('[Modal] Modal closed, active class removed');
  }
}

// Exportar funciones para uso externo
window.HubSpotModal = {
  open: openModal,
  close: closeModal
};
